import React from 'react';
import PropTypes from 'prop-types';

import { getAsset } from '../../../../../../../util/assets';

const propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
};

const FeatureItem = ({ icon, title }) => {
  return (
    <div className="photo-search-upsell-feature">
      <img src={getAsset(icon)} alt={title} height="60px" />
      <p className="mt-2">{title}</p>
    </div>
  );
};

FeatureItem.propTypes = propTypes;

export default FeatureItem;
